export class AcuerdoFirma {
  asignacionacuerdofirmaid: number = 0;
  usuariosubordinadoid: number = 0;
  nombresubordinado: string = "";
  nombrejefe: string = "";
  firmasubordinado: boolean = false;
  fechafirmasubordinado: any;
  usuariojefe:number = 0;
  firmajefe:boolean = false;
  fechafirmajefe:any;
  textoacuerdo:string = "";
  firmado: boolean = false;
  fechatermino:any;
  otropuesto:boolean = false;
  constructor(init?: Partial<AcuerdoFirma>) {
      Object.assign(this, init);
  }
}
